import React from 'react'
import { styled, Box, InputBase } from '@mui/material'
import { isNilOrEmpty } from 'packages/core'

const AttributeLabel = styled(Box)({
    fontSize: '1.2rem',
    lineHeight: 1.33,
    color: '#9b9b9b',
    textTransform: 'uppercase',
    minWidth: '20.4rem',
    display: 'block',
    wordBreak: 'break-word',
    wordWrap: 'break-word',
})

const AttributeValue = styled(Box)({
    fontSize: '1.2rem',
    lineHeight: 1.33,
    color: '#000000',
    width: '100%',
    display: 'block',
    wordBreak: 'break-word',
    wordWrap: 'break-word',
})

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    '& .MuiInputBase-input': {
        padding: 0,
        color: 'black !important',
    },
}))

const Attribute = (props) => {
    const { label, value, orientation, labelProps, valueProps, type, length } =
        props

    return (
        <Box
            display={orientation === 'vertical' ? 'inherit' : 'flex'}
            sx={{ paddingY: '0.85rem' }}
        >
            <AttributeLabel {...labelProps}>{label}</AttributeLabel>
            <AttributeValue
                sx={{ marginTop: orientation === 'vertical' ? '1.2rem' : 0 }}
                {...valueProps}
            >
                {type === 'password' ? (
                    <StyledInputBase
                        value={'*'.repeat(length ? length : 5)}
                        type={'password'}
                        disabled
                    />
                ) : isNilOrEmpty(value) ? (
                    '-'
                ) : (
                    value
                )}
            </AttributeValue>
        </Box>
    )
}

Attribute.defaultProps = {
    orientation: 'horizontal',
}

export default Attribute
